/* ============================================================================
   catalog-count.js - vault + pantry product counts for marketing copy
   ============================================================================ */

import { isMembersPantryProduct } from "./subscription.js?v=20261007m";
import { isVariantSkuProduct } from "./vault-product-meta.js?v=20261007m";

const VAULT_HIDDEN_CATEGORIES = new Set(["Code", "Master Exclusive"]);

export function isVaultListedProduct(product) {
  if (!product) return false;
  if (isVariantSkuProduct(product.id) || product.variant_sku) return false;
  if (VAULT_HIDDEN_CATEGORIES.has(product.category)) return false;
  if (product.master_exclusive) return false;
  if (isMembersPantryProduct(product)) return false;
  return true;
}

/** Count vault-listed SKUs + Members Pantry items. */
export function countCatalogProducts(products = []) {
  let vault = 0;
  let pantry = 0;
  for (const product of products) {
    if (isMembersPantryProduct(product)) pantry += 1;
    else if (isVaultListedProduct(product)) vault += 1;
  }
  return { vault, pantry, total: vault + pantry };
}

/** Marketing stat floors to the nearest 5 (47 → 45, 50 → 50). */
export function marketingAssetCount(total) {
  const n = Math.max(0, Math.floor(Number(total) || 0));
  if (n <= 0) return 0;
  return Math.floor(n / 5) * 5;
}

export function formatMarketingAssetCount(total) {
  const n = marketingAssetCount(total);
  return n > 0 ? `${n}+` : "0";
}

export function paintHeroAssetCount(products, root = document) {
  const el = root.getElementById?.("hero-asset-count") || document.getElementById("hero-asset-count");
  if (!el) return;
  const { total } = countCatalogProducts(products);
  el.textContent = formatMarketingAssetCount(total);
}

export function paintHeroAssetCountFromTotal(total, root = document) {
  const el = root.getElementById?.("hero-asset-count") || document.getElementById("hero-asset-count");
  if (!el) return;
  el.textContent = formatMarketingAssetCount(total);
}

export function cacheMarketingAssetTotal(products) {
  try {
    const { total } = countCatalogProducts(products);
    sessionStorage.setItem("ccj_marketing_asset_total", String(total));
    return total;
  } catch (_) {
    return 0;
  }
}

export function readCachedMarketingAssetTotal() {
  try {
    const n = Number(sessionStorage.getItem("ccj_marketing_asset_total"));
    return Number.isFinite(n) && n > 0 ? n : null;
  } catch (_) {
    return null;
  }
}
